import type { LucideIcon } from "lucide-react"
import { TabsList, TabsTrigger } from "@/components/ui/tabs"
import { cn } from "@/lib/utils"
import type { ChatbotStatus } from "@/lib/types"

type EditorTab = { value: string; label: string; shortLabel: string; description: string; icon: LucideIcon }

export function EditorNav({ tabs, validTabs, domainCount, status, mobileOpen = false }: { tabs: readonly EditorTab[]; validTabs?: ReadonlySet<string>; domainCount?: number; status: ChatbotStatus; mobileOpen?: boolean }) {
  return (
    <div className="relative z-20 flex h-auto w-full shrink-0 flex-col border-b border-border bg-card lg:h-full lg:w-[248px] lg:border-b-0 lg:border-r">
      {/* Mobile Horizontal Tabs */}
      <div className={cn("overflow-x-auto border-b border-border bg-card p-2 custom-scrollbar lg:hidden", !mobileOpen && "hidden")}>
        <TabsList className="grid h-auto min-w-[520px] grid-cols-4 gap-1 bg-transparent p-0">
          {tabs.map(({ value, shortLabel, icon: Icon }) => (
            <TabsTrigger
              key={value}
              value={value}
              className="group flex h-10 items-center justify-center gap-1.5 rounded-lg px-2 text-xs font-semibold transition-all data-[state=active]:bg-accent data-[state=active]:text-accent-foreground data-[state=active]:shadow-none"
            >
              <Icon className="size-3.5 shrink-0" />
              <span className="truncate text-[11px]">{shortLabel}</span>
            </TabsTrigger>
          ))}
        </TabsList>
      </div>

      {/* Desktop Vertical Sidebar Tabs */}
      <TabsList className="hidden flex-1 w-full flex-col items-stretch justify-start gap-1 bg-transparent px-4 py-7 lg:flex">
        <p className="mb-2 px-3 text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
          Configurar assistente
        </p>
        {tabs.map(({ value, label, icon: Icon }) => (
          <TabsTrigger
            key={value}
            value={value}
              className="group relative flex h-11 w-full items-center justify-start gap-3 rounded-xl px-3 text-left text-[13px] text-muted-foreground transition-colors data-[state=active]:bg-accent data-[state=active]:font-semibold data-[state=active]:text-accent-foreground hover:bg-accent/70 hover:text-accent-foreground"
          >
            <Icon className="size-4 shrink-0" />
            <span className="min-w-0 flex-1 truncate">{label}</span>
          </TabsTrigger>
        ))}

        <div className="mt-auto border-t border-border pt-3">
          <div className="flex items-center justify-between rounded-lg border border-border bg-muted/40 px-3 py-2 text-xs text-muted-foreground">
            <span className="text-[11px] font-medium">{status === "active" ? "Ativo" : "Inativo"}</span>
            <span className="text-[10px]">
              {domainCount ? `${domainCount} domínio${domainCount === 1 ? "" : "s"}` : "0 domínios"}
            </span>
          </div>
        </div>
      </TabsList>
    </div>
  )
}
